import { render } from "./FormQuizMultiple.vue?vue&type=template&id=3c1ffe7b"
import script from "./FormQuizMultiple.vue?vue&type=script&lang=js"
export * from "./FormQuizMultiple.vue?vue&type=script&lang=js"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__